import React, { FC } from 'react';
import { Select } from 'antd';
import { useAllLocations } from '~/hooks/locations';

const LocationInput: FC<any> = (props) => {
  const { data, isFetching } = useAllLocations();
  const options = Array.isArray(data)
    ? data.map((item) => ({ value: item.id as string, label: item.name }))
    : [];

  return (
    <Select
      loading={isFetching}
      options={options}
      filterOption={(inputValue, option) =>
        (option?.label as string)?.toUpperCase().indexOf(inputValue?.toUpperCase()) !== -1
      }
      showSearch
      {...props}
    />
  );
};

export default LocationInput;
